﻿export const modalState = function () {
	return {
		isOpen: false,

		/**
		 * Sets the alpine component state. Adds a class to the document root body element that sets overflow to hidden. This
		 * does remove the scrollbar but potentially has some other drawbacks. 
		 * 
		 * TODO: If this is important for UX, we should probably use https://www.npmjs.com/package/body-scroll-lock
		 * to cover all the situations
		 * 
		 * @param {boolean} value
		 */
		setModalState: function (value) {
			console.log(value);
			if (value) {
				document.body.classList.add('ftui__modal--open');
			} else {
				document.body.classList.remove('ftui__modal--open');
			}

			this.isOpen = value;
		}
	};
};